<template>
  <ElTooltip
    placement="top"
    :disabled="!release.actions.disabledPublish"
    :content="$t('APP.RELEASES.DISABLE_PUBLISH_ERROR')"
  >
    <div>
      <ElButton
        size="small"
        type="primary"
        :loading="loading"
        :disabled="release.actions.disabledPublish"
        @click="confirmToPublish"
      >
        {{ this.$t('APP.RELEASES.PUBLISH_RELEASE') }}
      </ElButton>
    </div>
  </ElTooltip>
</template>

<script>
import { PUBLISH_RELEASE } from '@/store/types';
import packageName from '@/mixins/packageName';
import { mapActions } from 'vuex';

export default {
  name: 'PublishReleaseButton',
  mixins: [packageName],
  props: {
    release: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    ...mapActions({ publishReleaseAndUpdateStore: PUBLISH_RELEASE }),
    confirmToPublish() {
      return this.$confirm(
        this.$t('APP.RELEASES.ARE_YOU_SURE'),
        this.$t('APP.RELEASES.PUBLISH_RELEASE'),
        {
          confirmButtonText: this.$t('APP.RELEASES.PUBLISH'),
          cancelButtonText: this.$t('CANCEL'),
          type: 'success',
        },
      )
        .then(this.publishRelease)
        .catch(() => {});
    },
    publishRelease() {
      this.loading = true;
      const { token } = this.release;
      return this.publishReleaseAndUpdateStore({
        packageName: this.packageName,
        token,
      })
        .then(message => {
          if (message) {
            this.$message.success(message);
          }
        })
        .catch(({ message }) => {
          if (message) {
            this.$message.error(message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
